__turbopack_context__.v({
  "card": "SimilarListings-module__qqzG8q__card",
  "pageButton": "SimilarListings-module__qqzG8q__pageButton",
  "track": "SimilarListings-module__qqzG8q__track",
  "viewport": "SimilarListings-module__qqzG8q__viewport",
});
